import React, { Component } from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import createHistory from "history/createBrowserHistory";
import ReactGA from "react-ga";
import { Helmet } from "react-helmet";

import "../../vendor/bootstrap4/css/bootstrap.min.css";
import "../../vendor/font-awesome/css/font-awesome.min.css";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import Career from "../../routes/Career/Career";
import Contact from "../../routes/Contact/Contact";
import StartPage from "../../routes/StartPage/StartPage";
import NotFound from "../../routes/NotFound/NotFound";
import Services from "../../routes/Services/Services";

import CareerUiux from "../../routes/Career/CareerUiux";
import CareerFrontend from "../../routes/Career/CareerFrontend";
import CareerBackend from "../../routes/Career/CareerBackend";
import "./App.css";

class App extends Component {
  constructor(props) {
    super(props);
    this.routeButtonClick = this.routeButtonClick.bind(this);
  }

  routeButtonClick(category, name) {
    ReactGA.event({
      category: category,
      action: "Click",
      label: name
    });
  }
  render() {
    ReactGA.set({ page: window.location.pathname + window.location.search });
    ReactGA.pageview(window.location.pathname + window.location.search);
    var history = createHistory(this.props);
    const routes = [
      {
        path: "/",
        exact: true,
        content: () => <StartPage click_function={this.routeButtonClick} />
      },
      {
        path: "/services/:scroll?",
        content: props => <Services {...props} />
      },
      {
        path: "/career",
        exact: true,
        content: () => <Career click_function={this.routeButtonClick} />
      },
      {
        path: "/career/uiux",
        exact: true,
        content: () => {
          return (
            <CareerUiux
              title="UI / UX"
              click_function={this.routeButtonClick}
            />
          );
        }
      },
      {
        path: "/career/frontend",
        exact: true,
        content: () => {
          return (
            <CareerFrontend
              title="Frontend"
              click_function={this.routeButtonClick}
            />
          );
        }
      },
      {
        path: "/career/backend",
        exact: true,
        content: () => {
          return (
            <CareerBackend
              title="Backend"
              click_function={this.routeButtonClick}
            />
          );
        }
      },
      {
        path: "/contact/:scroll?",
        content: props => <Contact {...props}/>
      },
      {
        path: "/404",
        content: () => <NotFound />
      }
    ];
    history.listen(function() {
      ReactGA.set({ page: window.location.pathname + window.location.search });
      ReactGA.pageview(window.location.pathname + window.location.search);
      if(window.location.pathname !== "/contact/form" || window.location.pathname !== "/services/scroll"){
        window.scrollTo(0, 0);
      }
    });

    return (
      <div>
        <Helmet>
          <title>Corviva</title>
          <meta name="description" content="Digital plattform för enkäter, undersökningar och möten riktat
           till företag och organisationer som arbetar inom hälsa och arbetsmiljö." />
          <meta name="keywords" content="webbportal hälsa företagshälsovård arbetsmiljö hälsoundersökning fhv" />
          <meta property="og:site_name" content="Corviva" />
          <meta property="og:image" content={"http://www.corviva.se" + require("../../assets/images/backgrounds/Startsida.jpg") }/>
        </Helmet>
        <HashRouter history={history}>
          <div>
            <Navbar click_function={this.routeButtonClick} />
            <Switch>
              {routes.map(route => {
                return (
                  <Route
                    key={"content_route"}
                    path={route.path}
                    exact={route.exact}
                    render={props => {
                      return <route.content {...props} />;
                    }}
                  />
                );
              })}
              <Redirect to="/404" />
            </Switch>
            <Footer click_function={this.routeButtonClick} />
          </div>
        </HashRouter>
      </div>
    );
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.jsx